module.exports = __webpack_public_path__ + "img/sp001.ad89bd13.jpeg";